/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import type * as Types from '../../../../__generated__/zeus/types';

import type { DocumentTypeDecoration } from '@graphql-typed-document-node/core';
/** Address prefix used to find on-market listings. */
export type MarketplaceAddressSearchInput = {
  query: Types.Scalars['NonEmptyString']['input'];
};

export type MarketplaceZoneSearchInput = {
  latitude?: Types.Scalars['Latitude']['input'] | null | undefined;
  limit?: Types.Scalars['SafeInt']['input'] | null | undefined;
  longitude?: Types.Scalars['Longitude']['input'] | null | undefined;
  query: Types.Scalars['NonEmptyString']['input'];
  types?: Array<MarketplaceZoneType> | null | undefined;
};

export type MarketplaceZoneType =
  | 'CITY'
  | 'COUNTY'
  | 'MACRO_NEIGHBORHOOD'
  | 'NEIGHBORHOOD'
  | 'RESIDENTIAL_BOUNDARY'
  | 'STATE'
  | 'SUBNEIGHBORHOOD'
  | 'UNKNOWN'
  | 'ZIP_CODE';

export type MarketplacePropertySuggestionFragment = { addressId: Types.Scalars['UUID']['output'], fullAddress: Types.Scalars['String']['output'] | null, listPriceCents: Types.Scalars['SafeInt']['output'] | null };

export type MarketplaceLocationSuggestionsQueryVariables = Exact<{
  propertyInput: Types.MarketplaceAddressSearchInput;
  zoneInput: Types.MarketplaceZoneSearchInput;
}>;


export type MarketplaceLocationSuggestionsQuery = { marketplace: { addressSearch: Array<{ addressId: Types.Scalars['UUID']['output'], fullAddress: Types.Scalars['String']['output'] | null, listPriceCents: Types.Scalars['SafeInt']['output'] | null }> | null, searchZones: Array<{ zone: { id: Types.Scalars['ID']['output'], name: Types.Scalars['NonEmptyString']['output'], population: Types.Scalars['SafeInt']['output'] | null, stateAbbr: Types.Scalars['String']['output'] | null, type: Types.MarketplaceZoneType, center: { latitude: Types.Scalars['Latitude']['output'], longitude: Types.Scalars['Longitude']['output'] } | null } }> | null } };

export class TypedDocumentString<TResult, TVariables>
  extends String
  implements DocumentTypeDecoration<TResult, TVariables>
{
  __apiType?: NonNullable<DocumentTypeDecoration<TResult, TVariables>['__apiType']>;
  private value: string;
  public __meta__?: Record<string, any> | undefined;

  constructor(value: string, __meta__?: Record<string, any> | undefined) {
    super(value);
    this.value = value;
    this.__meta__ = __meta__;
  }

  override toString(): string & DocumentTypeDecoration<TResult, TVariables> {
    return this.value;
  }
}
export const MarketplacePropertySuggestionFragmentDoc = /*#__PURE__*/ new TypedDocumentString(`
    fragment MarketplacePropertySuggestion on MarketplaceListing {
  addressId
  fullAddress
  listPriceCents
}
    `, {"fragmentName":"MarketplacePropertySuggestion"}) as unknown as TypedDocumentString<MarketplacePropertySuggestionFragment, unknown>;
export const MarketplaceLocationSuggestionsDocument = /*#__PURE__*/ new TypedDocumentString(`
    query MarketplaceLocationSuggestions($propertyInput: MarketplaceAddressSearchInput!, $zoneInput: MarketplaceZoneSearchInput!) {
  marketplace {
    addressSearch(input: $propertyInput) {
      ...MarketplacePropertySuggestion
    }
    searchZones(input: $zoneInput) {
      zone {
        center {
          latitude
          longitude
        }
        id
        name
        population
        stateAbbr
        type
      }
    }
  }
}
    fragment MarketplacePropertySuggestion on MarketplaceListing {
  addressId
  fullAddress
  listPriceCents
}`) as unknown as TypedDocumentString<MarketplaceLocationSuggestionsQuery, MarketplaceLocationSuggestionsQueryVariables>;